import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import * as React from 'react';

const YOUTUBE_RE = /\[youtube ([\w-]+) (\d+) (\d+)\]/;

// Input: "[youtube gF9Ee4zJ8eo 560 315]"
// Output: <iframe width="560" height="315" src="https://www.youtube.com/embed/gF9Ee4zJ8eo" frameborder="0" allowfullscreen />

export const youtubize = (text: TextLike, remove: boolean = false) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];
    const matcher = new RegExp(YOUTUBE_RE, 'g');
    let from = 0;
    while (true) {
        const match = matcher.exec(s);
        if (match) {
            const matchLen = match[0].length;
            const code = match[1];
            const width = match[2];
            const height = match[3];

            const to = matcher.lastIndex - matchLen;

            // copy text before this link
            ret.push(s.substring(from, to));

            // insert embedded youtube iframe
            if (!remove) {
                ret.push(getYoutubeIframe(code, width, height));
            }

            from = matcher.lastIndex;
        } else {
            // copy text after last link
            ret.push(s.substring(from));
            break;
        }
    }
    return ret;
});

export const getYoutubeIframe = (code: string, width: number | string, height: number | string) => {

    const src = `https://www.youtube.com/embed/${code}`;

    return (
        <iframe
            width={width}
            height={height}
            src={src}
            frameBorder="0"
            // gesture="media"
            // allow="encrypted-media"
            allowFullScreen
        />
    );
};

export const deyoutubize = (text: TextLike) => youtubize(text, true);
